export default function Credibility() {
    const credentials = [
        '4.5+ years of professional design experience',
        'Branding, communication design, illustration',
        'Experience across consumer brands, systems, and storytelling-led work',
    ];

    return (
        <section className="py-16 md:py-20 border-t border-warm-gray-200">
            <div className="max-w-3xl">
                {/* Credentials List */}
                <ul className="space-y-3 mb-8">
                    {credentials.map((item, index) => (
                        <li
                            key={index}
                            className="flex items-start gap-3 text-warm-gray-700"
                        >
                            <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                            <span className="text-body-lg">{item}</span>
                        </li>
                    ))}
                </ul>

                {/* Supporting Text */}
                <p className="text-body-lg text-warm-gray-600 max-w-prose">
                    I've worked across fast-moving teams and slower, craft-driven projects — learning when to simplify, and when to lean into detail.
                </p>
            </div>
        </section>
    );
}
